// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
import { firebaseWebConfig } from "../config/firebaseEnv";

const firebaseConfig = firebaseWebConfig;

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);


export default firebaseApp;